import * as ImagePicker from 'react-native-image-picker'

export default ImagePicker
